import { TooltipedIconComponent } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { MaterialDefinitionsRowActionsStyled } from './material-definitions-row-actions.style';

interface MaterialDefinitionsRowActionsProps {
    materialId: string;
    materialName: string;
    onEdit: (materialId: string) => void;
    onDelete: (materialId: string, materialName: string) => void;
}

export const MaterialDefinitionsRowActionsComponent: React.FC<MaterialDefinitionsRowActionsProps> = ({
    materialId,
    materialName,
    onEdit,
    onDelete,
}) => {
    const { t } = useTranslation();

    const handleOnEdit = (ev: React.MouseEvent) => {
        ev.stopPropagation();
        onEdit(materialId);
    };

    const handleOnDelete = (ev: React.MouseEvent) => {
        ev.stopPropagation();
        onDelete(materialId, materialName);
    };

    return (
        <MaterialDefinitionsRowActionsStyled>
            <TooltipedIconComponent
                dataTestId={`options-menu-${materialId}-edit`}
                tooltipText={t('settings.materials.material-definitions.row-actions.edit')}
                onClick={handleOnEdit}
                icon="write"
                family="outlined"
            />
            <TooltipedIconComponent
                dataTestId={`options-menu-${materialId}-delete`}
                tooltipText={t('settings.materials.material-definitions.row-actions.delete')}
                onClick={handleOnDelete}
                icon="delete"
                family="outlined"
            />
        </MaterialDefinitionsRowActionsStyled>
    );
};
